<template>
    <div class="data-update">
        <el-dialog title="修改" :visible.sync="dialogFormVisible" style="text-align:left">
        <el-form 
            :model="enterpriseData" 
            label-width='80px' 
            ref="dataRef"
            @keyup.enter.native="submitData"
        >
            <el-form-item label="企业名称" label-width="120px">
            <el-input 
                v-model="enterpriseData.enterpriseName" 
                autocomplete="off"
            >
            </el-input>
            </el-form-item>
            <el-form-item label="企业统一社会信用代码" label-width="120px">
            <el-input v-model="enterpriseData.enterpriseCode" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="诚信企业承诺书模板" label-width="120px">
            <el-input v-model="enterpriseData.areaCode" autocomplete="off" type="textarea" rows="3"></el-input>
            </el-form-item>
            <el-form-item label="企业联系人" label-width="120px">
            <el-input v-model="enterpriseData.mainPerson" autocomplete="off" type="textarea" rows="3"></el-input>
            </el-form-item>
            <el-form-item label="联系人号码" label-width="120px">
            <el-input v-model="enterpriseData.telephone" autocomplete="off" type="textarea" rows="3"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitData">确 定</el-button>
        </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    methods: {
        init(id){
            this.dialogFormVisible=true
            this.enterpriseData.id = id || 0;
            if(this.enterpriseData.id){
                this.$ajaxGet(`/enterprise/info/open/${this.enterpriseData.id}`).then(({data}) => {
                    if(data.code ===0){
                        this.enterpriseData = data.data
                    }
                })
            }
        },
        //点击确定按钮
        submitData(){
            this.$refs.dataRef.validate(valid => {
                console.log(valid)
                if(valid){
                    this.$ajaxPost('/enterprise/update',this.enterpriseData).then(({data}) => {
                        console.log(data)
                        if(data.code===0){
                            this.$emit('integrityEnterpriseUpdate')
                            this.dialogFormVisible = false
                            this.$message.success('修改成功')
                        }         
                    })
                }
                else{
                    return false
                }
            })
        },
    },         
    data() {
        return {
            dialogFormVisible: false,
            //诚信企业修改或添加参数
            enterpriseData:{
                id:null,
                enterpriseName:'',
                enterpriseCode:'',
                introduction:'',
                mainPerson:'',
                telephone:'',
            },
        }
    },
}
</script>